// Date-range helpers shared by the sticky date bar and the reports that use it.
// Dates are 'YYYY-MM-DD' strings in local time.

const MONTHS_SHORT = ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יוני', 'יולי', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'];

export function iso(d) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export function parse(s) {
  const p = (s || '').slice(0, 10).split('-').map(Number);
  return new Date(p[0], p[1] - 1, p[2]);
}

export function addDays(s, n) {
  const d = parse(s);
  d.setDate(d.getDate() + n);
  return iso(d);
}

export function daysBetween(start, end) {
  return Math.round((parse(end) - parse(start)) / 86400000) + 1;
}

// Presets end yesterday: today's numbers are still incomplete in GA4 and GSC.
export function presetRange(key) {
  const today = new Date();
  const yesterday = iso(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1));
  if (key === 'all') return { preset: 'all', start: null, end: null };
  if (key === 'this_month') {
    const first = iso(new Date(today.getFullYear(), today.getMonth(), 1));
    return { preset: key, start: first > yesterday ? yesterday : first, end: yesterday };
  }
  if (key === 'last_month') {
    return {
      preset: key,
      start: iso(new Date(today.getFullYear(), today.getMonth() - 1, 1)),
      end: iso(new Date(today.getFullYear(), today.getMonth(), 0)),
    };
  }
  const days = parseInt(key, 10);
  return { preset: key, start: addDays(yesterday, -(days - 1)), end: yesterday };
}

export const PRESET_LABELS = {
  all: 'כל התקופה', 7: '7 ימים', 14: '14 ימים', 28: '28 ימים', 30: '30 ימים', 90: '90 ימים',
  180: '180 ימים', 365: 'שנה', this_month: 'החודש', last_month: 'החודש שעבר',
};

// '6 באוק׳ 2026'
export function longDate(s) {
  const d = parse(s);
  return d.getDate() + ' ב' + MONTHS_SHORT[d.getMonth()] + ' ' + d.getFullYear();
}

// '1–30 בספט׳ 2026', '29 בספט׳ – 5 באוק׳ 2026', '20 בדצמ׳ 2025 – 3 בינו׳ 2026'
export function rangeText(start, end) {
  if (!start || !end) return '';
  const a = parse(start), b = parse(end);
  if (start === end) return longDate(start);
  if (a.getFullYear() !== b.getFullYear()) return longDate(start) + ' – ' + longDate(end);
  if (a.getMonth() !== b.getMonth()) {
    return a.getDate() + ' ב' + MONTHS_SHORT[a.getMonth()] + ' – ' + longDate(end);
  }
  return a.getDate() + '–' + b.getDate() + ' ב' + MONTHS_SHORT[b.getMonth()] + ' ' + b.getFullYear();
}

// Compact axis label for a 7-day bucket ending on `end`: '6–12/10', or '29/9–5/10' across months.
export function weekLabel(end) {
  const b = parse(end);
  const a = parse(addDays(end, -6));
  return a.getMonth() === b.getMonth()
    ? a.getDate() + '–' + b.getDate() + '/' + (b.getMonth() + 1)
    : a.getDate() + '/' + (a.getMonth() + 1) + '–' + b.getDate() + '/' + (b.getMonth() + 1);
}

// Full text for the same bucket, for hover: '6–12 באוק׳ 2026'
export function weekText(end) {
  return rangeText(addDays(end, -6), end);
}
